<snelstart-ui-dialog-definition [(visible)]="dialogVisible"
                                [useTitleBorder]="true"
                                id="ms"
                                size="xl"
                                title="Briefopmaak instellingen">
<snelstart-ui-dialog-header-content>
  Een briefopmaak wordt gebruikt als template voor het genereren van aanbiedingsbrieven bij fiscale aangiften en samenstelverklaringen bij
  jaarrekeningen.
</snelstart-ui-dialog-header-content>
  <snelstart-ui-dialog-body>
    <div class="office-template-layout">
      <div class="office-template-left">
        <form [formGroup]="officeTemplateFormGroup">
          <div class="a4-editor">
            <div class="margin-top">
              <snelstart-ui-text-form-control
                class="custom-input-120"
                formControlName="marginTop"
                id="marginTop"
                label="Bovenmarge">
              </snelstart-ui-text-form-control>
            </div>

            <div class="margin-left">
              <snelstart-ui-text-form-control
                class="custom-input-90"
                formControlName="marginLeft"
                id="marginLeft"
                label="Linkermarge">
              </snelstart-ui-text-form-control>
            </div>

            <div class="a4-preview">
              <div class="a4-page">
                @if (headerPreviewUrl && headerPreviewStyle) {
                  <img
                    [src]="headerPreviewUrl"
                    alt="Header preview"
                    class="a4-header-logo"
                    [ngStyle]="headerPreviewStyle"
                  >
                }

                <div
                  class="a4-content-area"
                  [style.top.px]="toPreviewY(+(officeTemplateFormGroup.get('marginTop')?.value || 0))"
                  [style.right.px]="toPreviewX(+(officeTemplateFormGroup.get('marginRight')?.value || 0))"
                  [style.bottom.px]="toPreviewY(+(officeTemplateFormGroup.get('marginBottom')?.value || 0))"
                  [style.left.px]="toPreviewX(+(officeTemplateFormGroup.get('marginLeft')?.value || 0))"
                ></div>

                @if (officeTemplateFormGroup.get('footerType')?.value === 'image' && footerPreviewUrl && footerPreviewStyle) {
                  <img
                    [src]="footerPreviewUrl"
                    alt="Footer preview"
                    class="a4-footer-logo"
                    [ngStyle]="footerPreviewStyle"
                  >
                }

                @if (officeTemplateFormGroup.get('footerType')?.value === 'text') {
                  <div
                    class="a4-footer-text"
                    [style.bottom.px]="toPreviewY(+(officeTemplateFormGroup.get('marginBottom')?.value || 0))">
                    {{ officeTemplateFormGroup.get('footerText')?.value }}
                  </div>
                }
              </div>
            </div>

            <div class="margin-right">
              <snelstart-ui-text-form-control
                class="custom-input-90"
                formControlName="marginRight"
                id="marginRight"
                label="Rechtermarge">
              </snelstart-ui-text-form-control>
            </div>

            <div class="margin-bottom">
              <snelstart-ui-text-form-control
                class="custom-input-120"
                formControlName="marginBottom"
                id="marginBottom"
                label="Ondermarge">
              </snelstart-ui-text-form-control>
            </div>
          </div>
        </form>
      </div>

      <div class="office-template-right">
        <form [formGroup]="officeTemplateFormGroup">
          <snelstart-ui-select-form-control
            [options]="logoPositionOptions"
            class="custom-input-250"
            formControlName="headerLogoPosition"
            id="headerLogoPosition"
            label="Positie logo">
          </snelstart-ui-select-form-control>

          <div class="upload-block">
            <input
              #headerUpload
              (change)="onHeaderLogoSelected($event)"
              accept="image/*"
              class="file-input"
              type="file"
            >
            <snelstart-ui-button
              (click)="headerUpload.click()"
              class="upload-btn"
              icon="cloud-arrow-up"
              type="secondary">
              Upload logo
            </snelstart-ui-button>
          </div>
          <snelstart-ui-select-form-control
            [options]="footerTypeOptions"
            class="custom-input-250"
            formControlName="footerType"
            id="footerType"
            label="Footer type">
          </snelstart-ui-select-form-control>

          @if (officeTemplateFormGroup.get('footerType')?.value === 'text') {
            <snelstart-ui-textarea-form-control
              [rows]="6"
              class="custom-input-250"
              formControlName="footerText"
              id="footerText"
              label="Footertekst">
            </snelstart-ui-textarea-form-control>
          }

          @if (officeTemplateFormGroup.get('footerType')?.value === 'image') {
            <div class="upload-block">
              <input
                #footerUpload
                (change)="onFooterLogoSelected($event)"
                accept="image/*"
                class="file-input"
                type="file"
              >
              <snelstart-ui-button
                (click)="footerUpload.click()"
                class="upload-btn"
                icon="cloud-arrow-up"
                type="secondary">
                Upload footer
              </snelstart-ui-button>
            </div>
          }
        </form>
      </div>
    </div>
  </snelstart-ui-dialog-body>

  <snelstart-ui-dialog-buttons class="d-flex">
    <snelstart-ui-button (click)="dialogVisibleChange.emit(false)" btn-x class="me-1" id="cancel" type="secondary">
      Annuleren
    </snelstart-ui-button>
    <snelstart-ui-button (click)="this.saveTemplate()" icon="check" id="save" type="primary">
      Opslaan
    </snelstart-ui-button>
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
